// src/App.js

import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import TemplateEditorPage from './pages/TemplateEditorPage';
import SettingsPage from './pages/SettingsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import BrandingPage from './pages/BrandingPage';
import NavBar from './components/Layout/NavBar';
import Footer from './components/Layout/Footer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import themeConfig from './theme';
import { Box } from '@mui/material';

import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

// Use the same Amplify configuration as your old project
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: "6b90agk2p4g04g5m2tpc27rejv",
      userPoolId: "us-east-2_xzDnCbCEO",
      loginWith: {
        email: "true",
      },
    },
  },
});

function App() {
  const location = useLocation();
  const theme = createTheme(themeConfig);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Authenticator variation="modal">
        {({ signOut, user }) => (
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <NavBar />
            <Box sx={{ flex: 1 }}>
              <Routes>
                {/* Use location.key as a key so Home remounts each time */}
                <Route path="/" element={<Home key={location.key} />} />
                <Route path="/template-editor" element={<TemplateEditorPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/branding" element={<BrandingPage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        )}
      </Authenticator>
    </ThemeProvider>
  );
}

export default App;
